module.exports = __webpack_public_path__ + "media/24.42facf79.mp3";